export default function Films() {
  return <div>N/A</div>;
}
